import ProjectTemplate from '../../components/common/ProjectTemplate';
import ConveyorViewerContainer from '../../components/conveyor/ConveyorViewerContainer';

const ConveyorViewerPage = () => {
    return (
        <ProjectTemplate>
            <ConveyorViewerContainer />
        </ProjectTemplate>
    );
};

export default ConveyorViewerPage;
